/**
 * The legacy portal routes `/(makeoffer|makeoffers|make-offer|make-offers)/:page?`:
 * the landing is `/make-offer/start`, and any other segment is a listing slug —
 * the URL an agent lands on after address entry looks like
 * `/make-offer/3859-Briggs-Rd-Columbus-OH-43228`. The bare path redirects to
 * the landing.
 */
export type PortalRoute =
  | { kind: 'landing' }
  | { kind: 'confirmation' }
  | { kind: 'redirect'; destination: string }
  | { kind: 'listing'; slug: string }
  | { kind: 'notFound' };

const PORTAL_BASE_PATH = '/make-offer';

const PORTAL_LANDING_PATH = `${PORTAL_BASE_PATH}/start`;

export const portalListingPath = (slug: string): string => `${PORTAL_BASE_PATH}/${slug}`;

export const resolvePortalRoute = (segments: string | string[] | undefined): PortalRoute => {
  const requested = [segments ?? []].flat();
  if (requested.length === 0) {
    return { kind: 'redirect', destination: PORTAL_LANDING_PATH };
  }
  if (requested.length > 1) {
    return { kind: 'notFound' };
  }

  const [segment] = requested;
  if (segment === 'start') {
    return { kind: 'landing' };
  }
  if (segment === 'confirm') {
    return { kind: 'confirmation' };
  }
  // 'error' was the legacy portal's reserved failure page; submission errors
  // now surface inline, so the segment goes back to the start.
  if (segment === 'error') {
    return { kind: 'redirect', destination: PORTAL_LANDING_PATH };
  }
  // Any other segment is an opaque listing-slug candidate, as in the legacy
  // router's default branch — Rails' build_slug preserves punctuation like
  // apostrophes, so a shape check here would 404 real listings. The upstream
  // listing fetch is the arbiter.
  return { kind: 'listing', slug: segment };
};
